<app-display-header></app-display-header>
<div class="message">
  <p>Tehnički problem <span>Out of order</span></p>
  <div class="train"></div>
</div>
